import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { AcceptInviteShell } from "./accept-invite-shell";

interface WelcomeStepProps {
  firstName: string;
  onGetStarted: () => void;
  isSending: boolean;
}

export function WelcomeStep({
  firstName,
  onGetStarted,
  isSending,
}: WelcomeStepProps) {
  return (
    <AcceptInviteShell>
      <div className="mt-8 space-y-4">
        <h1 className="text-4xl font-bold leading-[0.98] tracking-tight text-balance text-black sm:text-5xl">
          Hey{firstName ? ` ${firstName}` : ""}, glad you&apos;re here
        </h1>
        <p className="text-[15px] leading-relaxed text-muted-foreground text-pretty">
          Somethings connects teens with trained young-adult mentors. Setting up
          your profile takes about 10 minutes, and you can stop and come back
          anytime.
        </p>
      </div>
      <Button
        onClick={onGetStarted}
        disabled={isSending}
        className="mt-8 h-[52px] w-full rounded-full bg-black text-base font-semibold text-white hover:bg-black/90"
      >
        {isSending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        Get Started!
      </Button>
    </AcceptInviteShell>
  );
}
